import { Component, OnInit, OnDestroy } from "@angular/core";
import { SubSink } from "subsink";
import { HttpEventType } from "@angular/common/http";

import { TeamService } from "@/core/services";
import { Member, TeamTexts } from "@/core/models";
import { ConfigurationService } from "@/shared-module/services";
import { Configuration } from "@/shared-module/models";

@Component({ templateUrl: "team.component.html" })
export class TeamComponent implements OnInit, OnDestroy {
  configuration: Configuration;
  nextDecision: Date;
  subs = new SubSink();
  demoparameters: any;
  members: Member[];
  displayView = "list";
  memberEdited: Member;
  errorMessage: string;
  toastMessage: string;
  texts: TeamTexts;

  constructor(
    private configurationService: ConfigurationService,
    private teamService: TeamService,
  ) {}

  ngOnInit() {
    const thisObject = this;
    this.subs.sink = this.configurationService.config.subscribe(
      (c: Configuration) => {
        thisObject.configuration = c;
        this.configurationService.redirectIfDisabled();
      },
    );

    this.teamService.getTexts().subscribe((list) => {
      this.texts = list;
    });

    this.displayAndRefreshList();
  }

  addMemberClicked(evt) {
    this.errorMessage = null;
    this.memberEdited = new Member();
    this.displayView = "edit";
  }

  lostPasswordClicked(evt) {
    this.errorMessage = null;
    this.memberEdited = new Member();
    this.displayView = "password";
  }

  updateMemberClicked(evt) {
    this.errorMessage = null;
    this.memberEdited = this.members.find(
      (x: Member) => x.subUserId === evt,
    ) as Member;
    this.displayView = "edit";
  }

  removeMemberClicked(evt) {
    this.errorMessage = null;
    this.memberEdited = this.members.find(
      (x: Member) => x.subUserId === evt,
    ) as Member;
    this.displayView = "remove";
  }

  editCancelled(evt) {
    this.displayView = "list";
  }

  removeCancelled(evt) {
    this.displayView = "list";
  }

  lostPasswordCancelled(evt) {
    this.displayView = "list";
  }

  lostPasswordSubmitted(evt) {
    this.errorMessage = null;
    this.memberEdited.universityId = evt.universityId;
    this.memberEdited.email = evt.email;

    this.teamService.remindPassword(this.memberEdited).subscribe((valid) => {
      if ((valid as any).status === 3) {
        this.errorMessage = (valid as any).statusText;
      }

      if ((valid as any).status === 0) {
        this.displayAndRefreshList();
        this.toast((valid as any).statusText);
      }
    });
  }

  removeSubmitted(evt) {
    this.errorMessage = null;
    this.memberEdited.userName = evt.userName;
    this.memberEdited.password = evt.password;

    this.teamService.validateLogin(this.memberEdited).subscribe((valid) => {
      if ((valid as any).status === 2) {
        this.errorMessage = (valid as any).statusText;
      }

      if ((valid as any).status === 0) {
        this.teamService.removeMember(this.memberEdited).subscribe((m) => {
          this.displayAndRefreshList();
          this.toast((m as any).statusText);
        });
      }
    });
  }

  editSubmitted(evt) {
    this.errorMessage = null;
    this.memberEdited.email = evt.email;
    this.memberEdited.userName = evt.userName;
    this.memberEdited.password = evt.password;
    this.memberEdited.universityId = evt.universityId;
    this.memberEdited.email = evt.email;
    this.memberEdited.firstName = evt.firstName;
    this.memberEdited.lastName = evt.lastName;

    if (this.memberEdited.subUserId) {
      this.teamService.validateLogin(this.memberEdited).subscribe((valid) => {
        if ((valid as any).status === 2) {
          this.errorMessage = (valid as any).statusText;
        }

        if ((valid as any).status === 0) {
          if (evt.image) {
            this.teamService.uploadPhoto(evt.image).subscribe((event) => {
              if (event.type === HttpEventType.Response) {
                this.memberEdited.photoId = (event.body as any).documentId;
                this.teamService
                  .updateMember(this.memberEdited)
                  .subscribe((m) => {
                    this.displayAndRefreshList();
                    this.toast((m as any).statusText);
                  });
              }
            });
          } else {
            this.teamService.updateMember(this.memberEdited).subscribe((m) => {
              this.displayAndRefreshList();
              this.toast((m as any).statusText);
            });
          }
        }
      });
    } else {
      this.teamService.validateMember(this.memberEdited).subscribe((valid) => {
        if ((valid as any).status === 1) {
          this.errorMessage = (valid as any).statusText;
        }

        if ((valid as any).status === 0) {
          if (evt.image) {
            this.teamService.uploadPhoto(evt.image).subscribe((event) => {
              if (event.type === HttpEventType.Response) {
                this.memberEdited.photoId = (event.body as any).documentId;
                this.teamService
                  .createMember(this.memberEdited)
                  .subscribe((m) => {
                    this.displayAndRefreshList();
                    this.toast((m as any).statusText);
                  });
              }
            });
          } else {
            this.teamService.createMember(this.memberEdited).subscribe((m) => {
              this.displayAndRefreshList();
              this.toast((m as any).statusText);
            });
          }
        }
      });
    }
  }

  displayAndRefreshList() {
    this.teamService.getMembers().subscribe((list) => {
      this.displayView = "list";
      this.members = list;
    });
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  toast(message: string) {
    this.toastMessage = message;
    const x = document.getElementById("snackbar-black");
    x.classList.add("show");
    setTimeout(() => {
      x.className = x.className.replace("show", "");
    }, 3000);
  }
}
